'use client';

import { AnimatePresence } from 'framer-motion';
import { useNotificationStore } from '@/lib/stores/notification-store';
import { ModalComponent } from './modal';

export function ModalContainer() {
  const modals = useNotificationStore((state) => state.modals);

  return (
    <AnimatePresence mode="sync">
      {modals.map((modal) => (
        <ModalComponent key={modal.id} modal={modal} />
      ))}
    </AnimatePresence>
  );
}
